<template>
    <div class="company-article">
        <dl id="dl_en" class="hide">
            <dt>Vision</dt>
        <dd>Build Arivo into a world-renowned tyre brand. </dd>
        <dt>Mission</dt>
        <dd>Establish the globalization and diversified sustainable development
               of brand Arivo, serve every user all over the world.</dd>
        <dt>Strategy</dt>
        <dd>Focus on the construction and development of brand Arivo
              Strive to achieve a win-win situation for User and Partner.</dd>
        <dt>Philosophy</dt>
        <dd>Innovation -- Thought, Technology, Product & operational Model innovation</dd>
        <dd>Profession -- Technology, Management, Marketing and Service professional</dd>
        <dd>Quality -- Honest, Trustworthy and Contribution, Seek Truth from the Facts</dd>
        <dd>Win-Win -- User, Partner, Team, Enterprise, Society and individual progress.</dd>
        <dt>Slogan</dt>
        <dd><strong>SAFETY, QUALITY & PERFORMANCE GO TOGETHER !!!</strong></dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "Cuture_Content",
  mounted: function() {
      $("#dl_en").addClass("show").removeClass("hide");
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/company/culture_content.vue